export enum HeroHeadlineSize {
	LARGE = 'large',
	MEDIUM = 'medium',
	SMALL = 'small',
}
